import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { useMediaQuery } from "@mui/material";
import LoginAunty from "../../assets/images/png/girlFile.png";
import i18n from "../../i18n";
import { useLocation, useHistory } from "react-router-dom";
import "./fewMoreDetail.scss";
import imagethankyou from "../../assets/images/svg/newDesign/ThankYouImage.png";
import tick from "../../assets/images/svg/newDesign/check-tick.svg";
import Cookies from "js-cookie";
import encryptStorage from "../../utils/encryptStorage";
import loadingGif from "../../assets/images/gif/loader_gif.gif";
import grayCheck from "../../assets/images/svg/gray-check.svg";
import greenCheck from "../../assets/images/svg/green-check.svg";
import axios from "axios";
import moment from "moment";
import Loader from "../../uiComponents/loader/Loader";
import logo1 from "../../assets/images/svg/newDesign/logo1.svg";
import back from "../../assets/images/svg/newDesign/back.svg";
import logo from "../../assets/images/svg/newDesign/logo.svg";
import call from "../../assets/images/svg/newDesign/call.svg";
import new11 from "../../assets/images/svg/newDesign/new11.svg";
import new12 from "../../assets/images/svg/newDesign/new12.svg";
import new13 from "../../assets/images/svg/newDesign/new13.svg";
import new14 from "../../assets/images/svg/newDesign/new14.svg";
import { useSelector } from "react-redux";

const SignupThankyou = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const [showCalendar, setShowCalendar] = useState(false);
  const [bookingTime, setBookingTime] = useState("");
  const [bookingDate, setBookingDate] = useState("");
  const uniqueCode = encryptStorage.getItem("unique_code");
  const [apiUrl, setApiUrl] = useState(null);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location.state) {
      sessionStorage.setItem("apiUrl", location?.state?.apiUrl);
    }
  }, [location.state]);


  let calendlyToken = `${process.env.REACT_APP_CALENDLY_AUTH}`


  useEffect(() => {
    const storedUrl = sessionStorage.getItem("apiUrl");
    if (storedUrl) {
      setApiUrl(storedUrl);
    }
  }, []);

  useEffect(() => {
    if (apiUrl) {
      axios
        .get(apiUrl, {
          headers: {
            Authorization: calendlyToken,
          },
        })
        .then((res) => {
          const startTime = res?.data?.resource?.start_time;

          if (startTime) {
            const formattedDateTime = moment(startTime)
              .local()
              .format("dddd, MMM DD, YYYY - hh:mm A")
              .toUpperCase();

            setBookingTime(formattedDateTime);
          }
        })
        .catch((err) => {
          console.error("Error fetching booking time:", err);
        });
    }
  }, [apiUrl]);

  useEffect(() => {
    sessionStorage.setItem("alreadyShow", "alreadyshown");
  }, []);
  
  const navigateToHomePage = () => {
    Cookies.remove("token");
    window.location.href="/signup-number";
  };

  return (
    <>
      <StyledThankyou className="thankyouscreen">
        {(!bookingTime) && <Loader />}
        {!isMobile && (
          <div className="header_meriSehat bg-white d-none d-lg-block">
            <Container fluid>
              <Row>
                <Col md={12}>
                  <div className="logo_only">
                    {/* <Link to="/"> */}
                    <img src={logo} className="logoEU" alt="Logo" />
                    {/* </Link> */}

                    <p className="phoneNumber">
                      <img src={call} className="logoEU" alt="Logo" />
                      (021)-111-111-111
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        )}

        <Container style={{ paddingBottom: isMobile ? "40px " : "90px", display: isMobile ? "flex" : "", justifyContent: isMobile ? "center" : "" }}>
          <div className="boxThankyou thankyou-doctor">
            <Row className="my-120">
              {!isMobile && (
                <Col md={5} className="order-2 order-md-1 mt-3 mt-md-0">
                  <img
                    src={imagethankyou}
                    className="img-fluid"
                    alt=""
                  />
                </Col>
              )}
              <Col
                md={6}
                className="order-1 order-md-2 text-center bookedAreaBooking"
              >
                <div className="thankyou-container">
                  <img src={tick} className="img-fluid"></img>
                  <h1 className="thankyou-time-booked">
                    {i18n.t("Thank you, your time slot has been booked")}
                  </h1>
                  <div className="card flexOrder d-flex bg-white p-4 mt-5">
                    <div className="borderstyle text-center boxnew01">
                      <img
                        src={new11}
                        alt=""
                        className="img-fluid"
                        style={{
                          width: isMobile ? "28.338px" : "",
                          height: isMobile ? "28.329px" : "",
                        }}
                      />
                      <div className="ms-2">
                        <h6 className="mb-0 active">Register</h6>
                      </div>
                    </div>
                    <div className="borderstyle text-center boxnew01">
                      <img
                        src={new12}
                        alt=""
                        className="img-fluid"
                        style={{
                          width: isMobile ? "28.338px" : "",
                          height: isMobile ? "28.329px" : "",
                        }}
                      />
                      <div className="ms-2">
                        <h6 className="mb-0 active">Availability</h6>
                      </div>
                    </div>
                    <div className="borderstyle text-center boxnew01">
                      <img
                        src={new13}
                        alt=""
                        className="img-fluid"
                        style={{
                          width: isMobile ? "28.338px" : "",
                          height: isMobile ? "28.329px" : "",
                        }}
                      />
                      <div className="ms-2">
                        <h6 className="mb-0"> Orientation </h6>
                      </div>
                    </div>
                    <div className="text-center boxnew01">
                      <img
                        src={new14}
                        alt=""
                        className="img-fluid"
                        style={{
                          width: isMobile ? "28.338px" : "",
                          height: isMobile ? "28.329px" : "",
                        }}
                      />
                      <div className="ms-2">
                        <h6 className="mb-0"> verification</h6>
                      </div>
                    </div>
                  </div>
                  <p className="text-uppercase para-application">
                    {i18n.t(
                      "You will now be called for an orientation session while we verify your PMDC number and will also be given a walk through our platform and its features."
                    )}
                  </p>
                  
                  <div className="">
                    <p className="  timeBookedSlot">
                       {bookingTime}
                    </p>
                    <div className="">
                      <button
                        type="submit"
                        className="btn-okay"
                        onClick={navigateToHomePage}
                      >
                        Return to Home Page
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </StyledThankyou>
    </>
  );
};

export const StyledThankyou = styled.section`
  .thankyou-heading {
    font-family: "Satoshi-Medium";
    font-style: normal;
    font-weight: 500;
    font-size: 26px;
    line-height: 35px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #313131;
    justify-content: center;
  }

  .ContactText {
    font-family: "Satoshi-Medium";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    /* or 125% */

    text-align: center;

    color: #292929;
    font-family: "Satoshi-Medium";
    font-style: normal;
    font-weight: 450;
    display: flex;
    align-items: center;
    text-align: center;

    color: #ef6286;
  }

  .saveText {
    font-family: "Satoshi-Light";
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 20px;
    /* or 125% */

    text-align: center;

    color: #292929;
    font-family: "Satoshi-Light";
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #313131;
  }

  .classPadding {
    padding: 0 9rem;
  }

  .bg-black {
    width: 60% !important ;
    margin: 1rem auto !important;
  }

  .para-application {
    font-family: "Satoshi-Light";
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 23px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #313131;
    justify-content: center;
  }

  .image-below {
    position: fixed;
    left: 0;
    bottom: 0;
  }

  .application-number {
    border-radius: 10px;
    border: none;
    width: fit-content;
    background: #cfeced;
    border-radius: 12.4651px;
    font-family: "Satoshi-Bold";
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 30px;
    /* display: flex; */
    /* align-items: center; */
    text-align: center;
    letter-spacing: 0.06em;
    color: #1fa7a8;
    max-width: 150px;

    input {
      font-family: "Satoshi-Medium";
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 30px;
      display: flex;
      align-items: center;
      text-align: center;
      letter-spacing: 0.06em;

      color: #313131;
    }
    input::placeholder {
      color: #1fa7a8;
    }
  }
 

  .pinkBookedColor {
    background: #ef6286;
    color: white;
  }
  .pinkBookedColor::placeholder {
    color: white;
  }
`;

export default SignupThankyou;
